import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';
import LoadingIndicator from "flarum/components/LoadingIndicator";
import icon from 'flarum/common/helpers/icon';

import UserSubmitModal from "./modal/UserSubmitModal";
import QueryListItem from "./QueryListItem";

export default class QuerySidebarComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.viewType = this.attrs.viewType;
    this.loading = true;
    this.moreResults = false;
    this.u2diInfoQueries = [];

    this.loading = true;
    this.listFilters = Stream("-1");
    this.listSort = Stream("desc");
    this.searchKeyword = "";
    this.searchKeywordTemp = Stream("");
    this.loadResult();
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const u2diInfoQueries = this.u2diInfoQueries;

    let counter = 0;
    let loading;

    if (this.loading) {
      loading = LoadingIndicator.component({ size: "large" });
    }

    return (
      <div>
        {this.viewType==="normal" && (
          <div className="u2diMapSideBarTitleContainier">
            <div className="u2diMapSideBarTitle">{app.translator.trans("ziven-u2di.forum.map-sidebar-query-title")}</div>

            {u2diUserType9===true && (
              <div className="u2diMapSideBarMagageArea u2diInfoItemContainer">
                <div style="width:85px;position: relative;">
                  <Select className="u2diDataSelectList" value={this.listFilters()}
                    style = "width:85px"
                    disabled={this.loading}
                    options={{
                      "-1":app.translator.trans("ziven-u2di.forum.map-query-filter-all"),
                      "0":app.translator.trans("ziven-u2di.forum.map-query-filter-zx"),
                      "1":app.translator.trans("ziven-u2di.forum.map-query-filter-gt"),
                      "2":app.translator.trans("ziven-u2di.forum.map-query-filter-wj"),
                    }}
                    onchange={(e) => { 
                      this.listFilters(e); 
                      this.filterItem(e)
                    }}
                  />

                  <div style="right: -9px" className="u2diDataSort" onclick={(e) => { this.sortItem(e) }}>
                    <i style={this.listSort()==="asc"?"color:var(--primary-color)":""} class="fas fa-sort-up"></i>
                    <i style={this.listSort()==="desc"?"color:var(--primary-color)":""} class="fas fa-sort-down"></i>
                  </div>
                </div>

                <div>
                  <div role="search" aria-label="Search Forum" class="Search">
                    <div className="Search-input">
                      <input disabled={this.loading} style="width: 160px !important;" oninput={(e) => { this.searchKeywordTemp(e.target.value) }} onsearch={(e) => {this.searchInput(e)}} className="FormControl u2diUserSearchInput" type="search" placeholder={app.translator.trans('ziven-u2di.forum.map-sidebar-query-manage-search-info')} />
                      {this.searchKeywordTemp()!=="" && (
                        <button className="Search-clear Button Button--icon Button--link" type="button" onclick={this.clearSearch.bind(this)}>
                          {icon('fas fa-times-circle')}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div style="height: calc(100vh - 340px)" className="u2diMapSideBarContentContainier">
              {u2diInfoQueries.map((infoQueryData) => {
                return (
                  <div id={"u2diQuery"+infoQueryData.id()} style="padding-top: 15px;">
                    {QueryListItem.component({ infoQueryData })}
                  </div>
                );
              })}

              {!this.loading && u2diInfoQueries.length===0 && (
                <div>
                  <div style="font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;">{app.translator.trans("ziven-u2di.lib.list-empty")}</div>
                </div>
              )}

              {!loading && this.hasMoreResults() && (
                <div className="u2di-loadMore" style="text-align:center;padding:20px">
                  <Button className={'Button Button--primary'} disabled={this.loading} loading={this.loading} onclick={() => this.loadMore()}>
                    {app.translator.trans('ziven-u2di.lib.load-more')}
                  </Button>
                </div>
              )}

              {loading && <div className="u2di-loadMore">{loading}</div>}
            </div>
          </div>
        )}

        {this.viewType==="mobile" && (
          <div className="u2diMapSideBarMobileContentArea">
            <div className="u2diMapSideBarMobileContentContainer">
              {u2diInfoQueries.map((infoQueryData) => {
                return (
                  <div style="padding-top: 5px;">
                    {QueryListItem.component({ infoQueryData })}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }

  clearSearch(e){
    $(e.target).parent().parent().find('input').val("");
    this.searchKeywordTemp("");
    this.searchInput();
  }

  searchInput(e){
    this.searchKeyword = this.searchKeywordTemp();
    this.filterItem(e);
  }

  sortItem(e){
    const listSort = this.listSort();

    if(listSort==="desc"){
      this.listSort("asc");
    }else if(listSort==="asc"){
      this.listSort("desc");
    }

    this.u2diInfoQueries = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }

  filterItem(e){
    this.u2diInfoQueries = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.u2diInfoQueries, results);
    this.loading = false;
    m.redraw();

    return results;
  }

  loadMore() {
    this.loading = true;
    this.loadResult(this.u2diInfoQueries.length);
  }

  hasMoreResults() {
    return this.moreResults;
  }

  loadResult(offset = 0){
    const listFilters = parseInt(this.listFilters());
    const listSort = this.listSort();
    const filters = {
      keyword:this.searchKeyword
    };

    switch(listFilters){
      case 0: filters["newest"] = 0; break;
      case 1: filters["contacted"] = 1; break;
      case 2: filters["completed"] = 1; break;
    }

    if(listSort!==""){
      filters["sort"] = listSort
    }

    app.store
      .find("u2diInfoQueries", {
      filter:filters,
      page: {
        offset,
      },
    })
    .catch(() => {})
    .then(this.parseResults.bind(this));
  }

}